module.exports = __webpack_public_path__ + "static/img/banner-business-01.d6c9905.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-business-01.jpg
// module id = lUjG
// module chunks = 100